import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Scanner } from "@/features/labels/scanner/scanner";

export const Route = createFileRoute("/qr/")({
  // `invalid`: the server sends an address whose code is no label code here (`qrPath`).
  validateSearch: z.object({ invalid: z.string().max(200).optional() }),
  component: ScannerRoute,
});

function ScannerRoute() {
  const { invalid } = Route.useSearch();
  return <Scanner code={null} invalid={invalid ?? null} />;
}
